/* eslint-disable require-jsdoc */
import * as React from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Button,
  Menu,
  MenuItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

interface TopBarProps {
  signOut: () => void;
}

export function TopBar(props: TopBarProps) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <MenuIcon />
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={handleClose} component={Link} to="/">
                Main
              </MenuItem>
              <MenuItem onClick={handleClose} component={Link} to="/map">
                Map
              </MenuItem>
            </Menu>
          </IconButton>
          <Button
            color="inherit"
            style={{ marginLeft: 'auto', marginRight: '0' }}
            onClick={props.signOut}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
